import { Component } from 'react'
import GoogleAnalytics from 'react-ga'
import { withRouter } from 'react-router-dom'

import constants from 'constants/index'

if (constants.GOOGLE_ANALYTICS_ID) {
  GoogleAnalytics.initialize(constants.GOOGLE_ANALYTICS_ID)
}

const trackPage = (page) => {
  if (constants.GOOGLE_ANALYTICS_ID) {
    GoogleAnalytics.set({ page })
    GoogleAnalytics.pageview(page)
  }
}

class GoogleAnalyticsComponent extends Component {
  componentDidMount() {
    trackPage(this.props.location.pathname)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      trackPage(nextProps.location.pathname)
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(GoogleAnalyticsComponent)



// WEBPACK FOOTER //
// ./src/components/GoogleAnalytics/index.js